import { queryOptions } from "@tanstack/react-query"

import { queryKey as sessionQueryKey } from "@repo/supabase/hooks/use-session"
import { queryKey as userQueryKey } from "@repo/supabase/hooks/use-user"
import { getIsomorphicSupabaseClient } from "@repo/supabase/isomorphic-client"
import { requireSession } from "@repo/supabase/require-session"
import { requireUser } from "@repo/supabase/require-user"

export const getCurrentSessionQueryOptions = () =>
  queryOptions({
    queryKey: sessionQueryKey,
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const { session } = await requireSession(supabase)

      // We intentionally do not want to throw an error if the session is not found

      return session
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })

export const getCurrentUserQueryOptions = () =>
  queryOptions({
    queryKey: userQueryKey,
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const { user } = await requireUser(supabase)

      // We intentionally do not want to throw an error if the user is not found

      return user
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
